<template>
    <transition name="fade">
        <div class="vue-modal" v-show="open">
            <transition name="drop-in">
                <div class="vue-modal-inner" v-show="open" >
                    <div class="vue-modal-content shadow-lg" style="min-width: 600px; background-color: var(--form-color); color: var(--theme-text-main); border-radius: 15px; padding: 30px;">
                        <slot />
                        <p class="h3 text-seccess fw-bold">{{ this.pay_cash_title }}</p>
                        <!--<label title="PayCash">{{this.pay_cash_cash_amount}}</label>-->
                        <br>
                        <input type="text" class="form-control input-lg" name="cashAmount" v-on:keyup.enter="passCashAmount()"
                            id="cashAmount" v-model="selfCashAmount" @input="selfCashAmount = Math.min(selfCashAmount, cashAmount)"  :placeholder="cashAmount" style="font-size: 1.2em; background: rgba(0,0,0,0.2); border: 1px solid rgba(255,255,255,0.1); color: var(--theme-text-main); text-align: center;" />
                        <br>

                        <div style="display:flex; justify-content: space-between; margin-top: 20px; padding: 0 10px;">
                            <button @click="closePopUp" class="btn btn-danger btn-lg" style="min-width: 120px;">{{ this.pay_cash_close }}</button>
                            <button class="btn btn-success btn-lg" @click="passCashAmount()" style="min-width: 120px;">{{ this.pay_cash_add_payment }}</button>
                        </div>

                    </div>
                </div>
            </transition>
            <div class="col-sm-4"
                style="position:fixed;width:250px;height:300px; min-height: 200px;left:0px;bottom:-80px;margin-left: -15px;margin-right: -10px;">
                <numericpad :onInput="onInput" :onDelete="onDelete" :onReset="onReset" :show="true" />
            </div>
        </div>
    </transition>
</template>
<script>
import { ref, onMounted } from 'vue'
import commonServices from "@/shared/commonServices"
import numericpad from "@/components/SimpleKeyboard";
export default {
    mixins: [commonServices],

    components: {
        numericpad
    },
    name: "PayCash",
    data: function () {
        return {
            selfCashAmount: '',
        }
    },
    watch: {
        open(val) {
            if (val) {
                this.selfCashAmount = '';
            }
        }
    },

    methods: {
        onInput(key) {
            if (key == 11) {
                    this.selfCashAmount = (this.selfCashAmount + '0')
            } else {
                this.selfCashAmount = (this.selfCashAmount + key)
            }
             if (Number(this.selfCashAmount) > Number(this.cashAmount)) {
        this.selfCashAmount = this.cashAmount;
    }
            //this.getProduct(this.barcode);

        },
        onDelete() {
            this.selfCashAmount = this.selfCashAmount.slice(0, this.selfCashAmount.length - 1);
        },
        closePopUp(){
            this.selfCashAmount = '';
            this.close();
        },
        onReset() {
            this.selfCashAmount = "";
        },
        focusAmount() {
            this.$refs.cashAmount.focus();
        },

        passCashAmount() {

            let amount = this.selfCashAmount;

            // إذا لم يدخل المستخدم قيمة استخدم قيمة placeholder
            if (!amount) {
                amount = this.cashAmount;
            }

            this.$emit('getCashAmount', amount);
            this.selfCashAmount = '';
            this.close();
        },
    },
    props: {
        open: {
            type: Boolean,
            required: true
        },
        cashAmount: {
            type: String,
            required: true
        },
        pay_cash_title: {
            type: String,
            required: true
        },
        pay_cash_cash_amount: {
            type: String,
            required: true
        },
        pay_cash_add_payment: {
            type: String,
            required: true
        },
        pay_cash_close: {
            type: String,
            required: true
        },
    },

    mounted() {
        if (this.open) {
            this.selfCashAmount = '';
        }
    },
    setup(_, { emit }) {
        const close = () => {
            emit('close');
        };
        return { close };
    },
};
</script>
<style scoped>
*,
::before::after {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
}

.vue-modal {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    overflow-x: hidden;
    overflow-y: auto;
    background-color: rgba(0, 0, 0, 0.4);
    z-index: 1;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 1rem;
}

.vue-modal-inner {
    max-width: 90%;
    max-height: 90vh;
    margin: 0;
}

.vue-modal-content {
    position: relative;
    background-color: #fff;
    border: 5px solid rgba(0, 0, 0, 0.3);
    background-clip: padding-box;
    border-radius: 1rem;
    padding: 1rem;
    width: 600px;
    height: auto;
    max-height: 90vh;
    overflow: auto;
}

.fade-enter-active,
.fade-leave-active {
    transition: opacity 0.5s;
}

.fade-enter-from,
.fade-leave-to {
    opacity: 0;
}

.drop-in-enter-active,
.drop-in-leave-active {
    transition: all 0.3s ease-out;
}

.drop-in-enter-from,
.drop-in-leave-to {
    opacity: 0;
    transform: translateY(50px);
}

/*
@import "https://unpkg.com/primitive-ui/dist/css/main.css"
*/</style>
